import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Security, SecureRoute, ImplicitCallback } from '@okta/okta-react';
// import Profile from './components/pages/Profile';
import Navbar from './components/layout/Navbar';
import Home from './components/pages/Home';
import Staff from './components/pages/Staff';
import Login from './components/auth/Login';
import './App.css';
import OktaUsers from './components/pages/OktaUsers';
import BelieveUsers from './components/pages/BelieveUsers';

function onAuthRequired({ history }) {
  history.push('/login');
}

class App extends Component {
  render() {
    return (
      <Router>
        <Security
          issuer="https://dev-95143253.okta.com/oauth2/default"
          client_id="0oahyfjzaqTLoz93s5d7"
          // redirect_uri={window.location.origin +  + '/implicit/callback'}
          redirect_uri={'https://devokta.mindwavetech.com' + 'http://localhost:3000' + 'devokta.mindwavetech.com' + '/implicit/callback'}
          onAuthRequired={onAuthRequired}
        >
          <div className="App"> 
            <Navbar />
            <div className="container">
              <Route path="/" exact={true} component={Home} />
              <SecureRoute path="/staff" exact={true} component={Staff} />
              <Route
                path="/login"
                render={() => (
                  <Login baseUrl="https://dev-95143253.okta.com" />
                )}
              />
              <Route path="/implicit/callback" component={ImplicitCallback} />
              {/* <Route path="/Profile" component={Profile}/> */}
              <Route path="/okta-users" component={OktaUsers}/>
              <Route path="/believe-users" component={BelieveUsers}/>
            </div>
          </div>
        </Security>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js